export function saveToStorage(key, storage) {
  try {
    const historic = JSON.parse(localStorage.getItem(key) || '[]');

    const alreadyExists = historic.some((item) => item.id === storage.id);
    if (alreadyExists) return;

    if (historic.length > 9) {
      historic.shift();
    }

    historic.push(storage);
    localStorage.setItem(key, JSON.stringify(historic));
  } catch (error) {
    console.error('Erro ao salvar no localStorage:', error);
  }
}
